/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import {extend, RequestOptionsInit} from 'umi-request';
import {message} from 'antd';
import ClientId from './ClientId';
import Sign from './Sign';
import apiListProxy from '@/Proxys/apiListProxy';

/* 元素隐式具有“任意”类型，因为索引表达式不是“数字”类型 */
export declare interface CategoriesMap {
  [key: string]: string;
}

// const codeMessage: CategoriesMap = {
//     200: '服务器成功返回请求的数据。',
//     201: '新建或修改数据成功。',
//     202: '一个请求已经进入后台排队（异步任务）。',
//     204: '删除数据成功。',
//     400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
//     401: '用户没有权限（令牌、用户名、密码错误）。',
//     403: '用户得到授权，但是访问是被禁止的。',
//     404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
//     406: '请求的格式不可得。',
//     410: '请求的资源被永久删除，且不会再得到的。',
//     422: '当创建一个对象时，发生一个验证错误。',
//     500: '服务器发生错误，请检查服务器。',
//     502: '网关错误。',
//     503: '服务不可用，服务器暂时过载或维护。',
//     504: '网关超时。',
// };

// 接口报错时不进行提示的接口
/*
* 活动弹框
* 公告
* */
const notMessage = ['/api/bill/device/is_used_free_device', '/api/user/notice/info'];

/* 异常处理程序 */
const errorHandler = (error: { response: Response }): [boolean,Response] => {
  const {response} = error;
  if(response && response.status) {
    //const errorText: string = codeMessage[response.status] || response.statusText;
    //const {status, url} = response;
    // notification.error({
    //     message: `请求错误 ${status}: ${url}`,
    //     description: errorText,
    // });
  }
  return [true,response];
};

/* 请求头拦截 */
const headersInterceptors  = (url: string, options: RequestOptionsInit) => {

  let timestamp = (new Date()).valueOf();
  let clientId = ClientId();

  let userInfo = window.localStorage.getItem('userInfo')

  if (userInfo === 'undefined' || userInfo === undefined || userInfo === 'null' || userInfo === null) {
    userInfo = "{}";
  }

  const mobile = userInfo ? JSON.parse(userInfo).mobile : options.data.mobile
  // 签名元素
  let signData = {clientType: 1, mobile: mobile, clientId: clientId, timestamp: timestamp}
  let pathArrar = ['/pub/user/login', '/pub/user/register', '/pub/user/forget', '/pub/user/vcode']
  let headers: any = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'clientType': 1,
    'mobile': mobile,
    'clientId': clientId,
    'timestamp': timestamp,
    'Sign': Sign.encrypt(options.data, signData),
    'appKey': '5WtKrLZP',
  }

  if(pathArrar.indexOf(url) !== -1) {
    if(url === '/pub/user/vcode' && Number(options.data.type) === 5) {
      // @ts-ignore
      headers.authInfo = JSON.parse(userInfo).token
    }
  } else {
    // @ts-ignore
    headers.authInfo = JSON.parse(userInfo).token
  }

  return ({options: {...options, headers}});
}

const responseInterceptors: any = async (response: Response, options: RequestOptionsInit) => {
  // 停服
  if(response.status === 503) {
    response.text().then(msg => {
      localStorage.setItem('stopMes', msg)
      window.location.replace("/stop");
    });
  }
  if (response.status !== 200) return response
  const data = await response.clone().json();
  if (data.code === 10000)  return [false, typeof data.result === 'object' && data.result !== null ? apiListProxy(data.result) : data.result];
  const showMessage = notMessage.includes(new URL(response.url).pathname)
  if(!showMessage) {
    message.error(typeof data.result === 'string' ? data.result : data.msg)
  }
  return [true, response]
}

/* 配置request请求时的默认参数 */
const request = extend({
  errorHandler, // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
});

/* 请求前拦截 */
request.interceptors.request.use(headersInterceptors);

/* 非正常请求状态拦截 */
request.interceptors.response.use(responseInterceptors);

export default request;
